"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.THRESHOLD_HOURS = exports.LOCALE_CONFIG = exports.DEFAULT_TIMEZONE = exports.DEFAULT_LOCALE = exports.DEFAULT_DATE_FORMAT = exports.DATE_FORMATS = exports.CARD_TIMER_TEXT_COLOR = exports.CARD_TIMER_ICON = void 0;
var DEFAULT_DATE_FORMAT = 'dd MMM';
exports.DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT;
var DEFAULT_TIMEZONE = 'Asia/Kuala_Lumpur';
exports.DEFAULT_TIMEZONE = DEFAULT_TIMEZONE;
var DATE_FORMATS = {
  'Default Format': DEFAULT_DATE_FORMAT,
  'month-date-year': 'MM-dd-yyyy',
  'date-month-year': 'dd-MM-yyyy',
  'year-month-date': 'yyyy-MM-dd',
  'month/date/year': 'MM/dd/yyyy',
  'date/month/year': 'dd/MM/yyyy',
  'year/month/date': 'yyyy/MM/dd',
  'Simple Date': 'MMM dd, yyyy',
  'Full Date': 'MMMM dd, yyyy',
  'Simple Day': 'EEE, dd MMM',
  'Full Day': 'EEEE, dd MMM'
};
exports.DATE_FORMATS = DATE_FORMATS;
var THRESHOLD_HOURS = 24;
exports.THRESHOLD_HOURS = THRESHOLD_HOURS;
var CARD_TIMER_ICON = 'AccessTimeIcon';
exports.CARD_TIMER_ICON = CARD_TIMER_ICON;
var CARD_TIMER_TEXT_COLOR = {
  START: 'tertiary',
  END: 'primary'
};
exports.CARD_TIMER_TEXT_COLOR = CARD_TIMER_TEXT_COLOR;
var LOCALE_CONFIG = {
  DATE: {
    month: 'short',
    day: 'numeric'
  },
  TIME: {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
  }
};
exports.LOCALE_CONFIG = LOCALE_CONFIG;
var DEFAULT_LOCALE = 'en-GB';
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;